export const catalogObj = {
  closeIcon: require('../../images/close.png'),
  searchIcon: require('../../images/search.png'),
  expandAllIcon: require('../../images/expand.png'),
  shrinkAllIcon: require('../../images/shrink.png'),
  checkboxIcon: require('../../images/checkboxyellow.png'),
  deleteIcon: require('../../images/delete.png')
};
